import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { Button, ColourInput, ColourSwatchInput } from '@payaca/ambrosia';
import { DEFAULT_COLOUR_PICKER_COLOURS } from '@payaca/constants/pipeline';
import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';

export type TProps = {
  value?: string;
  onChange?: (colour: string) => void;
};

const ColourPicker: FC<TProps> = (props) => {
  const { value, onChange } = props;

  return (
    <Popover className="h-full">
      <PopoverButton
        as={Button}
        size="sm"
        variant="secondary"
        className="h-full"
        aria-label="Pick stage colour"
      >
        <UntitledIcon
          className="size-6"
          name="circle.4"
          style={{ color: value }}
        />

        <UntitledIcon name="chevron-down" className="size-4" />
      </PopoverButton>

      <PopoverPanel
        anchor={{
          to: 'bottom start',
          gap: 8,
        }}
        focus
        className="bg-white rounded-md shadow-md z-popover border p-3"
      >
        <ColourPickerWithCustomPicker
          value={value}
          onChange={(hex) => onChange?.(hex)}
        />
      </PopoverPanel>
    </Popover>
  );
};

export const ColourPickerWithCustomPicker: FC<{
  value?: string;
  onChange: (hex: string) => void;
}> = (props) => {
  const { value, onChange } = props;

  return (
    <>
      <ColourSwatchInput
        value={value}
        colors={DEFAULT_COLOUR_PICKER_COLOURS}
        onChange={onChange}
      />

      <div className="mt-2.5">
        <p className="supporting-body text-gray-500 mb-1">Custom</p>
        <ColourInput value={value} onChange={onChange} />
      </div>
    </>
  );
};

export default ColourPicker;
